import { getAvatarColorIndex as e, getAvatarInitials as t } from "./primitive/utils.js";
import { AvatarPrimitive as n } from "./primitive/index.js";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
//#region src/avatar/avatar.tsx
function a({ src: e, firstName: a, lastName: o, displayName: s, initials: c, color: l, size: u = "lg", alt: d, rootProps: f, imageProps: p, fallbackProps: m }) {
	let h = c || t(a || o ? {
		firstName: a,
		lastName: o
	} : { displayName: s ?? null });
	return /* @__PURE__ */ i(n.Root, {
		...f,
		size: u,
		children: [/* @__PURE__ */ r(n.Image, {
			src: e ?? void 0,
			alt: d ?? s ?? "User avatar",
			...p
		}), /* @__PURE__ */ r(n.Fallback, {
			initials: h,
			color: l,
			...m
		})]
	});
}
var o = Object.assign(a, n, {
	getAvatarInitials: t,
	getAvatarColorIndex: e
});
//#endregion
export { o as Avatar };
